import './Styles/loading.css'
import React,{useContext} from 'react'
import Inicio from "./Sites/Inicio"
import Productos from "./Sites/Productos"
import Contactenos from "./Components/Contactenos"
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Menu from './Components/Menu';
import Footer from './Components/Footer'
import Error404 from './Sites/Error404';
import Producto from './Sites/Producto';
import ProductosTotales from './Sites/ProductosTotales'
import Login from './Sites/login'
import Admin from './Sites/Admin'

import RequireAuth from './Components/RequireAuth';
import { UserContext } from "./context/UserProvider"

import Edit from './Components/Admin/Edit'
import Create from './Components/Admin/Create'


//************Importaciones especiales ******************
import Navidad_Page from './Sites/navidad_Page';

function App () {

  const {user} = useContext(UserContext)

  if(user === false){
    return <div className='loader'></div>
  }


  return (
    <div className="app">
      
      <Router>
        <Menu/>
          <Routes>
            <Route path='/' exact element={<Inicio />} />
            
            <Route path='/productos' element={<ProductosTotales/>} />
            <Route path='/productosAlabastro' element={<Productos titulo="Alabastro"/>} />
            <Route path='/productosCristal' element={<Productos titulo="Cristal"/>} />
            <Route path='/productosFlores' element={<Productos titulo="Flores"/>} />
            <Route path='/productosManteleria' element={<Productos titulo="Manteleria"/>} />
            <Route path='/productosMurano' element={<Productos titulo="Murano"/>} />
            {/* <Route path='/productosNavidad' element={<Productos titulo="Navidad"/>} /> */}
            <Route path='/productosReligion' element={<Productos titulo="Religion"/>} />
            <Route path='/productosPoliresina' element={<Productos titulo="Poliresina"/>} />
            <Route path='/productosPorcelana' element={<Productos titulo="Porcelana"/>} />
            
            {/* Especiales */}
            <Route path='/productosNavidad' element={<Navidad_Page/>} />


            <Route path='/productos/producto/:id' element={<Producto/>}/>
            <Route path='/productosAlabastro/producto/:id' element={<Producto titulo='Alabastro'/>}/>
            <Route path='/productosCristal/producto/:id' element={<Producto titulo='Cristal'/>}/>
            <Route path='/productosFlores/producto/:id' element={<Producto titulo='Flores'/>}/>
            <Route path='/productosManteleria/producto/:id' element={<Producto titulo='Manteleria'/>}/>
            <Route path='/productosMurano/producto/:id' element={<Producto titulo='Murano'/>}/>
            <Route path='/productosNavidad/producto/:id' element={<Producto titulo='Navidad'/>}/>
            <Route path='/productosReligion/producto/:id' element={<Producto titulo='Religion'/>}/>
            <Route path='/productosPoliresina/producto/:id' element={<Producto titulo='Poliresina'/>}/>
            <Route path='/productosPorcelana/producto/:id' element={<Producto titulo='Porcelana'/>}/>
            
            <Route path='/contactenos' exact element={<Contactenos/>} />
            <Route path='/login' element={<Login/>} />
            <Route path='/admin' element={<RequireAuth><Admin/></RequireAuth>}/>
            <Route path='/admin/create' element={<RequireAuth><Create/></RequireAuth>}/>
            <Route path='/admin/edit/:id' element={<RequireAuth><Edit/></RequireAuth>}/>
            <Route path='/*' element={<Error404/>} /> 
          </Routes>
        <Footer/>
      </Router>
    </div>
  )
}

export default App;